<div class="img-wrapper" [ngStyle]="{'width': (width || 'auto'), 'height': (height || 'auto')}">
    <img [src]="url" 
        [ngClass]="{'image-full-width': (!!width && width !== 'auto'), 'image-full-height': (!!height && height !== 'auto')}"/>
</div>

